export default {
	rounds: [],
	activeChat: null
}
